export default "__VITE_ASSET__BpD07ox0__"